import { FunctionComponent, ReactNode } from 'react';
import { Languages } from '../top-menu/top-menu';

export type Props = {
  language: Languages;
  className?: string;
  style?: React.CSSProperties | undefined;
  href: string;
  children: ReactNode;
};

const A: FunctionComponent<Props> = (props) => {
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  return (
    <>
      {window.location.href.indexOf('/' + props.language + '/') !== -1 && (
        <a href={props.href} className={props.className} style={props.style}>
          {props.children}
        </a>
      )}
    </>
  );
};

export default A;
